import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';
import { TabComponent } from '../users/tab/tab.component';
import { FormStateService } from './add-sp-new-component/form-state.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ReloadService } from '../../Service/Reload-service/reload.service';

@Component({
  selector: 'app-service-provider',
  templateUrl: './service-provider.component.html',
  styleUrl: './service-provider.component.scss',
})
export class  ServiceProviderComponent implements OnInit {
  showModal = false;
  showPage = true;
  submittedCount: number = 0;
  inReviewCount: number = 0;
  approvedCount: number = 0;
  rejectedCount: number = 0;
  ref: DynamicDialogRef | undefined;
  activeIndex: number = 0;
  user:any
  status!: number;
  activeTab: 'submitted' | 'inReview' | 'approved' | 'rejected' = 'submitted';
  display: boolean = false;

  @ViewChild('submittedTab') submittedTab!: TabComponent;
  @ViewChild('inReviewTab') inReviewTab!: TabComponent;
  @ViewChild('approvedTab') approvedTab!: TabComponent;
  @ViewChild('rejectedTab') rejectedTab!: TabComponent;

  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private api: ServiceProviderService,
    private formStateService1: FormStateService,
    private route: ActivatedRoute,
    private router: Router,
    private reloadService: ReloadService
  ) { 
    // this.router.events
    // .pipe(filter((event) => event instanceof NavigationEnd))
    // .subscribe((event: any) => {
    //   if (event.url.includes('/admin/service-provider')) {
    //     this.fetchInitialData(); 
    //   }
    // });
  }
  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user') || '{}');
    this.reloadService.reloadList$.subscribe(() => {
      this.fetchInitialData();
    });
    this.route.url.subscribe((segments) => {
      const path = segments.map(seg => seg.path).join('/');
      if (path === 'add') {
        this.openModal(); // open add modal
      }
    });
    this.fetchInitialData()
  }
  openModal() {
    this.showModal = true
    this.router.navigate(['add-vehicle-service-provider'], { relativeTo: this.route });
  }
  // fetchInitialData(): void {
  //   const params = { status: this.activeIndex + 1 };

  //   this.api.getServiceProviderlist(params).subscribe((res: any) => {
  //     // Update counts for all tabs
  //     this.submittedCount = res.totalSubmittedRecord;
  //     this.inReviewCount = res.totalInReviewedRecord;
  //     this.approvedCount = res.totalApprovedRecord;
  //     this.rejectedCount = res.totalRejectedRecord;

  //     this.loadTabData(this.activeIndex, res.result.data, res.result.recordsFiltered);
  //   });
  // }

  fetchInitialData(): void {
  const params = { status: this.activeIndex + 1 };

  this.api.getServiceProviderlist(params).subscribe((res: any) => {
    // Update counts for all tabs
    this.submittedCount = res.totalSubmittedRecord;
    this.inReviewCount = res.totalInReviewedRecord;
    this.approvedCount = res.totalApprovedRecord;
    this.rejectedCount = res.totalRejectedRecord;

    // FIX: Use the correct total count for the active tab
    let totalRecords = 0;
    switch (this.activeIndex) {
      case 0:
        totalRecords = res.totalSubmittedRecord;
        break;
      case 1:
        totalRecords = res.totalInReviewedRecord;
        break;
      case 2:
        totalRecords = res.totalApprovedRecord;
        break;
      case 3:
        totalRecords = res.totalRejectedRecord;
        break;
      default:
        totalRecords = res.result.recordsFiltered;
    }
    this.loadTabData(this.activeIndex, res.result.data, totalRecords);
  });
}
  onTabChange(event: any) {
    const selectedIndex = event.index;
    this.activeIndex = selectedIndex;
    this.fetchTabData(selectedIndex);
  }

   
  // fetchTabData(index: number) {
  //   const params = { status: index + 1 };

  //   this.api.getServiceProviderlist(params).subscribe((res: any) => {
  //     this.loadTabData(index, res.result.data, res.result.recordsFiltered);
  //   });
  // }

  fetchTabData(index: number) {
  const params = { status: index + 1 };

  this.api.getServiceProviderlist(params).subscribe((res: any) => {
    // Pass the correct total count for each tab
    let totalRecords = 0;
    switch (index) {
      case 0:
        totalRecords = res.totalSubmittedRecord;
        break;
      case 1:
        totalRecords = res.totalInReviewedRecord;
        break;
      case 2:
        totalRecords = res.totalApprovedRecord;
        break;
      case 3:
        totalRecords = res.totalRejectedRecord;
        break;
      default:
        totalRecords = res.result.recordsFiltered;
    }
    this.loadTabData(index, res.result.data, totalRecords);
  });
}
  loadTabData(index: number, data: any[], totalRecords: number) {
    switch (index) {
      case 0:
        this.submittedTab.setData(data, totalRecords);
        break;
      case 1:
        this.inReviewTab.setData(data, totalRecords);
        break;
      case 2:
        this.approvedTab.setData(data, totalRecords);
        break;
      case 3:
        this.rejectedTab.setData(data, totalRecords);
        break;
      default:
        break;
    }
  }
  showAddSPPage() {
    this.showModal = true;
    this.showPage = false;
  }
  showModalW() {
    this.showModal = false
    this.router.navigate(['./'], { relativeTo: this.route });
  }
  updateListOnPaymentSuccess(): void {
    this.fetchInitialData();
    this.showModal = false;
  }
  closeAddDialog() {
    this.showModal = false;
    this.router.navigate(['./'], { relativeTo: this.route });
  }
}
